<template>
  <div class="ActiveTab InfoTab">
    <ActiveTabHeader :chargingpoint="chargingpoint">
      <h4>Locatieinformatie</h4>
    </ActiveTabHeader>

    <div class="ActiveTab__Content">
      <LocatieInformatieContent v-if="!isPlanModeActive" :chargingpoint="chargingpoint" />
      <LocatieInformatieEdit v-else />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ActiveTabHeader from "@/components/map/sidebar/ActiveTabHeader";
import LocatieInformatieContent from "@/components/map/sidebar/LocatieInformatieContent";
import LocatieInformatieEdit from "@/components/map/sidebar/LocatieInformatieEdit";

export default {
  components: {LocatieInformatieEdit, LocatieInformatieContent, ActiveTabHeader},
  computed: {
    ...mapGetters('planmode', {
      chargingpoint: 'getSelectedChargingpoint',
      isPlanModeActive: 'isActive',
    }),
  }
}
</script>

<style lang="scss">
@import "./src/assets/sass/config";

.LocatieInformatie__StreetViewImage {
  margin-bottom: 1rem;

  & > img {
    width: 50%;
  }
}

.LocatieInformatie__Content {
  color: #7F8FA4;
  //font-size: .9rem;

  strong {
    color: map_get($theme-colors, 'primary')
  }

  p {
    margin-bottom: .5rem
  }
}
</style>
